import { Injectable } from '@angular/core';
import { notificationError } from '@components/layout/error/error.utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationService } from '@service/notification.service';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
  loadNotificationListTeamsChats,
  loadNotificationListTeamsChatsFailure,
  loadNotificationListTeamsChatsSuccess,
  loadNotificationListTeamsChannels,
  loadNotificationListTeamsChannelsFailure,
  loadNotificationListTeamsChannelsSuccess,
  loadNotificationListTeamsCampaigns,
  loadNotificationListTeamsCampaignsFailure,
  loadNotificationListTeamsCampaignsSuccess,
} from './notification-list-teams.action';

@Injectable()
export class NotificationListTeamsEffect {
  constructor(
    private actions$: Actions,
    private notificationService: NotificationService
  ) {}

  loadChats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationListTeamsChats),
      mergeMap(({ currentPageNumber, filters, pageSize }) =>
        this.notificationService
          .searchTeamsChats(currentPageNumber, filters, pageSize)
          .pipe(
            map((body) => loadNotificationListTeamsChatsSuccess({ notificationList: body })),
            catchError((error) =>
              of(loadNotificationListTeamsChatsFailure({ error: notificationError(error) }))
            )
          )
      )
    )
  );

  loadChannels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationListTeamsChannels),
      mergeMap(({ currentPageNumber, filters, pageSize }) =>
        this.notificationService
          .searchTeamsChannels(currentPageNumber, filters, pageSize)
          .pipe(
            map((body) => loadNotificationListTeamsChannelsSuccess({ notificationList: body })),
            catchError((error) =>
              of(loadNotificationListTeamsChannelsFailure({ error: notificationError(error) }))
            )
          )
      )
    )
  );

  loadCampaigns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotificationListTeamsCampaigns),
      mergeMap(({ currentPageNumber, filters, pageSize }) =>
        this.notificationService
          .searchTeamsCampaigns(currentPageNumber, filters, pageSize)
          .pipe(
            map((body) => loadNotificationListTeamsCampaignsSuccess({ notificationList: body })),
            catchError((error) =>
              of(loadNotificationListTeamsCampaignsFailure({ error: notificationError(error) }))
            )
          )
      )
    )
  );
}
